/**
 * The one place the Raad business contact points live for the customer SPA.
 *
 * The WhatsApp business line and the support inbox are cited on the sign-in
 * screen (`features/auth/Login.tsx`) and on the two public legal pages
 * (`/privacy`, `/delete-account`), so a single source keeps them from drifting
 * apart — a stale number on a legal page is a compliance problem, not a typo.
 *
 * `wa.me` requires the number in international form with NO '+', spaces or
 * dashes, country code included: +252 90 779 0630 → 252907790630.
 */
export const WHATSAPP_NUMBER = '252907790630';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

/** Support inbox — the account/deletion contact Mahad approved (28 Sep 2026). */
export const SUPPORT_EMAIL = 'support@raadtelematics.com';
export const SUPPORT_EMAIL_URL = `mailto:${SUPPORT_EMAIL}`;
